import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectRuntimeProgramState } from '../../redux/RobotSlice';
import { RootState } from '../../redux/Store';
import { DRIVEBASE_SYSTEM_STATE } from '../../robot/drivebase-system-state';
import { RobotActions } from '../../utils/constants';

export interface ControllerFirmwareUpdateNotification {
  message: string;
  open: boolean;
  persistent: boolean;
}

/**
 * Shows a persistent snackbar while the drivebase overseer is waiting to update controller firmware.
 */
export const useControllerFirmwareUpdateNotification = (): ControllerFirmwareUpdateNotification => {
  const { t } = useTranslation();
  const runtimeProgramState = useSelector(selectRuntimeProgramState);
  const { robotState } = useSelector((state: RootState) => state.robot);

  const open = robotState === RobotActions.STATE.CONNECTED && runtimeProgramState === DRIVEBASE_SYSTEM_STATE.WAITING_FOR_FIRMWARE;

  return {
    message: t('controllerFirmwareUpdate.snackbar.message', {
      defaultValue: 'Controller update required. Connect your controller to your Drive Base with a USB cable.',
    }),
    open,
    persistent: true,
  };
};
